/**
 * Converts a number to include commas, if necessary.
 *
 * Source: http://stackoverflow.com/a/2901298
 *
 * @private
 * @param  {Number|String} n
 * @return {String}
 */
export default function numberWithCommas (n) {
  var parts = n.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}



// WEBPACK FOOTER //
// ./utils/number-with-commas.js